var $87505c9dab186d0f$exports = {};
$87505c9dab186d0f$exports = {
    "dismiss": `\u{5D4}\u{5EA}\u{5E2}\u{5DC}\u{5DD}`
};


export {$87505c9dab186d0f$exports as default};
//# sourceMappingURL=he-IL.module.js.map
